export default __webpack_public_path__ + "static/media/Background.f08a3189.svg";